import React, { useState } from 'react'

import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'

import { Device } from '@/lib/types'

import { useDialog } from '@/hooks/dialogs/useDialog'
import { useShopCardPaymentBlock } from '@/hooks/marketplace/useShopCardPaymentBlock'

import Button from '@/components/Button'
import Icon from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { DeviceInstallmentDialog } from '@/components/dialogs/shop/DeviceInstallmentDialog'
import { DeviceOrderDialog } from '@/components/dialogs/shop/DeviceOrderDialog'
import { ProfitTooltip } from '@/components/features/shop/ProfitTooltip'
import FormActions from '@/components/form/FormActions'

export const ShopCardPaymentBlock = ({
  device,
  className
}: {
  device: Device
  className?: string
}) => {
  const [isProfitVisible, setIsProfitVisible] = useState(false)

  const {
    isOpen: isOrderingOpen,
    closeModal: closeOrderingModal,
    openModal: openOrderingModal
  } = useDialog()

  const {
    isOpen: isInstallmentModalOpen,
    closeModal: closeInstallmentModal,
    openModal: openInstallmentModal
  } = useDialog()

  const { setDeviceOrderSchema, profit, onDeviceOrder, form } =
    useShopCardPaymentBlock({
      device,
      openOrderingModal,
      openInstallmentModal
    })

  const { annualForecast, currency, hasInstallment } = device

  return (
    <div
      className={clsx(
        'flex flex-col gap-3 border-t-[0.5px] border-slate-300 pt-4',
        'tablet:flex-row tablet:items-center tablet:justify-between',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <h5 className="text-right text-x-sm font-medium leading-x-sm tablet:text-left desktop:text-x-base desktop:leading-x-base">
          <FormattedMessage
            {...{
              id: 'device.profit.year',
              defaultMessage: 'Ожидаемая прибыль ~ {profit} в год',
              values: { profit }
            }}
          />{' '}
        </h5>
        <Tooltip
          className="hidden tablet:block"
          contentComponent={<ProfitTooltip {...{ annualForecast, currency }} />}
        >
          <button onClick={() => setIsProfitVisible((prev) => !prev)}>
            <Icon
              className="inline h-4 w-4 flex-none text-secondary-500"
              name="calculator-16"
            />
          </button>
        </Tooltip>
      </div>
      {isProfitVisible && (
        <ProfitTooltip
          className="tablet:hidden"
          {...{ annualForecast, currency }}
        />
      )}

      <FormActions
        className={clsx(
          'flex justify-end gap-4 tablet:ml-auto',
          hasInstallment && false ? 'grid-cols-2' : 'grid-cols-1'
        )}
      >
        {hasInstallment && false && (
          <Button
            className="px-7"
            onClick={() => onDeviceOrder(true)}
            variant="secondary"
          >
            <FormattedMessage
              {...{
                id: 'button.installment',
                defaultMessage: 'Рассрочка'
              }}
            />
          </Button>
        )}
        <Button
          className="w-full px-7 tablet:min-w-[143px]"
          onClick={onDeviceOrder}
        >
          <FormattedMessage
            {...{ id: 'button.buy', defaultMessage: 'Купить' }}
          />
        </Button>
        <DeviceOrderDialog
          {...{
            form,
            device,
            setDeviceOrderSchema,
            isOpen: isOrderingOpen,
            onClose: closeOrderingModal
          }}
        />
        <DeviceInstallmentDialog
          {...{
            form,
            device,
            setDeviceOrderSchema,
            isOpen: isInstallmentModalOpen,
            onClose: closeInstallmentModal
          }}
        />
      </FormActions>
    </div>
  )
}
